export const ASSISTANT_INTEREST_CONTEXT_REFRESH_INTERVAL_MS = 60_000;
